import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// ITAM-2583: Redux carries ONLY the cross-component "Join" signal — the one fact
// that must travel from <VideoConsultAlert> (Join click) to the app-level
// <ConsultOrderManager>. All lifecycle state (phase, dedupe, orderedConsultIds,
// grace timer, generations) is owned by useConsultOrderLifecycle; all PII/draft
// is owned by ConsultOrderContext. Neither lives here.

export interface ArmedConsult {
  consultId: number;
}

export interface ConsultOrderSliceState {
  armedConsult: ArmedConsult | null;
}

const initialState: ConsultOrderSliceState = {
  armedConsult: null,
};

const consultOrderSlice = createSlice({
  name: "consultOrder",
  initialState,
  reducers: {
    armConsultOrder: (state, action: PayloadAction<ArmedConsult>) => {
      state.armedConsult = action.payload;
    },
    clearArmed: (state) => {
      state.armedConsult = null;
    },
    resetConsultOrder: (state) => {
      state.armedConsult = null;
    },
  },
  extraReducers: (builder) => {
    // Clear the Join signal on logout (auth slice action type = "auth/logout").
    builder.addCase("auth/logout", (state) => {
      state.armedConsult = null;
    });
  },
});

export const consultOrderActions = consultOrderSlice.actions;

export default consultOrderSlice;
